import { Proposal, Quote } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum QuotesEffectsActions {
  SendRenewalInviteDialogConfirmed = '[QuotesEffects] Send Renewal Invite Dialog Confirmed',
  AdjustmentApplied = '[QuotesEffects] Renewal Adjustment Applied',
  ReturnDialogConfirmed = '[QuotesEffects] Return Dialog Confirmed',
  RequoteDialogConfirmed = '[QuotesEffects] Requote Dialog Confirmed',
  HoldDialogConfirmed = '[QuotesEffects] Hold Dialog Confirmed',
  SendToClientDialogConfirmed = '[QuotesEffects] Send To Client Dialog Confirmed',
  PaymentReceivedDialogConfirmed = '[QuotesEffects] Payment Received Dialog Confirmed',
  CompleteDialogConfirmed = '[QuotesEffects] Complete Dialog Confirmed',
  SubmitProposalConfirmed = '[QuotesEffects] Submit Proposal Confirmed',
  NotTakenUpConfirmed = '[QuotesEffects] Not Taken Up Confirmed',
  AcceptQuoteConfirmed = '[QuotesEffects] Accept Quote Confirmed',
  TNCConfirmed = '[QuotesEffects] Terms & Conditions Confirmed',
  ProposalBackupSet = '[QuotesEffects] Proposal Backup Set',
  ProposalBackupSaved = '[QuotesEffects] Proposal Backup Saved',
  ProposalBackupDeleted = '[QuotesEffects] Proposal Backup Deleted',
}

// Do not export this for use in other libs
export const LocalActions = {
  sendRenewalInviteDialogConfirmed: createAction(
    QuotesEffectsActions.SendRenewalInviteDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  returnDialogConfirmed: createAction(
    QuotesEffectsActions.ReturnDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  requoteDialogConfirmed: createAction(
    QuotesEffectsActions.RequoteDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  holdDialogConfirmed: createAction(
    QuotesEffectsActions.HoldDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  sendToClientDialogConfirmed: createAction(
    QuotesEffectsActions.SendToClientDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  paymentReceivedDialogConfirmed: createAction(
    QuotesEffectsActions.PaymentReceivedDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  completeDialogConfirmed: createAction(
    QuotesEffectsActions.CompleteDialogConfirmed,
    props<{ quote: Quote }>()
  ),
  submitProposalConfirmed: createAction(
    QuotesEffectsActions.SubmitProposalConfirmed,
    props<{ proposal: Proposal }>()
  ),
  notTakenUpConfirmed: createAction(
    QuotesEffectsActions.NotTakenUpConfirmed,
    props<{ quote: Quote }>()
  ),
  tncConfirmed: createAction(
    QuotesEffectsActions.TNCConfirmed,
    props<{ quote: Quote }>()
  ),
  acceptQuoteConfirmed: createAction(
    QuotesEffectsActions.AcceptQuoteConfirmed,
    props<{ quote: Quote }>()
  ),
  proposalBackupSet: createAction(
    QuotesEffectsActions.ProposalBackupSet,
    props<{ proposal: Proposal }>()
  ),
  proposalBackupDeleted: createAction(
    QuotesEffectsActions.ProposalBackupDeleted,
    props<{ proposalId: string }>()
  ),
  proposalBackupSaved: createAction(
    QuotesEffectsActions.ProposalBackupSaved,
    props<{ proposal: Proposal }>()
  ),
};
